export const NEW_ID_RANGE = 10000;
export const createNewUniquId = () => -Math.round(Math.random() * NEW_ID_RANGE);
